import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import SectionReveal from "./SectionReveal";

const LOGO_IMG =
  "https://customer-assets.emergentagent.com/job_5adba607-3cb4-4890-a176-530c0c902f8d/artifacts/ssy7xi7j_imgi_2_Banner_Familie.png";

const MILESTONES = [
  { year: "1949", title: "Fondata", text: "Gründung des Geschäfts in Binningen — der Kult beginnt." },
  { year: "1965", title: "Goldene Jahre", text: "Vespa wird zum Lebensgefühl: Werkstatt und Showroom in einem Haus." },
  { year: "1990", title: "Pony erobert die Schweiz", text: "Wir werden offizielle Anlaufstelle für das Schweizer Kult-Mofa Pony." },
  { year: "Heute", title: "Casa Markus Zürcher", text: "Geführt von Markus Zürcher in zweiter Generation. Tradition trifft Präzision." },
];

export default function Trust1949() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-60, 60]);

  return (
    <section
      id="tradition"
      ref={ref}
      className="section relative overflow-hidden bg-[var(--cream-alt)]"
      data-testid="tradition-section"
    >
      <motion.div
        style={{ y }}
        className="absolute -left-32 top-10 w-[40vw] max-w-[520px] aspect-square opacity-25 pointer-events-none"
        aria-hidden
      >
        <div
          className="w-full h-full bg-contain bg-no-repeat mix-blend-multiply"
          style={{ backgroundImage: `url(${LOGO_IMG})` }}
        />
      </motion.div>

      <div className="container-wide relative grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5 lg:sticky lg:top-32 self-start">
          <SectionReveal>
            <span className="overline">Tradition</span>
            <h2 className="h-display text-5xl md:text-6xl lg:text-7xl mt-6 text-[var(--anthracite)]">
              Fondata <span className="italic-accent text-[var(--sage-dark)]">nel 1949.</span>
            </h2>
            <p className="mt-8 text-base md:text-lg text-[var(--muted-fg)] leading-relaxed max-w-md">
              Zwei Generationen, ein Versprechen: Jede Vespa, die unser Haus verlässt, fährt mit
              der gleichen Hingabe wie unsere erste — vor über fünfundsiebzig Jahren.
            </p>
            <div className="mt-10 flex items-center gap-6">
              <div className="tricolore h-[3px] w-28" />
              <span className="font-serif italic text-2xl text-[var(--anthracite)]">
                La famiglia.
              </span>
            </div>
          </SectionReveal>
        </div>

        <div className="lg:col-span-7 lg:pl-12 lg:border-l lg:border-[var(--border)]">
          <ol className="space-y-16">
            {MILESTONES.map((m, i) => (
              <SectionReveal key={m.year} delay={i} as="li">
                <div className="grid grid-cols-[100px_1fr] md:grid-cols-[140px_1fr] gap-6 items-baseline">
                  <span className="font-serif text-4xl md:text-5xl text-[var(--sage-dark)] leading-none">
                    {m.year}
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-[var(--anthracite)] mb-3">
                      {m.title}
                    </h3>
                    <p className="text-[var(--muted-fg)] leading-relaxed">{m.text}</p>
                  </div>
                </div>
              </SectionReveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
